import { DailymotionProvider } from './models/daylimotion.provider';
import { OembedProviderInterface } from './models/oembed.provider.interface';
import { YoutubeProvider } from './models/youtube.provider';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'oembed',
  standalone: true,
})
export class OembedPipe implements PipeTransform {
  private readonly providers: OembedProviderInterface[] = [new YoutubeProvider(), new DailymotionProvider()];

  transform(htmlContent: string): any {
    let content = htmlContent;
    const oembedUrls = htmlContent.match(/<\s*oembed[^>]*>(.*?)<\s*\/\s*oembed>/g);

    if (!oembedUrls) {
      return content;
    }

    const iframes = oembedUrls
      .map((oembedUrl) => oembedUrl.split('url="')[1].split('"')[0])
      .map((url) => {
        let videoIframe: string | undefined = undefined;

        this.providers.every((provider) => {
          const id = provider.getId(url);

          if (!id) {
            return true;
          }

          videoIframe = provider.getVideo(id);
          return false;
        });
        return videoIframe;
      });

    oembedUrls.forEach((oembedUrl, index) => {
      if (iframes[index]) {
        content = content.replace(oembedUrl, iframes[index]!);
      }
    });

    return content;
  }
}
